import React from 'react';
import { Spin, Icon } from 'antd';
import styles from './Loader.module.scss';

const Loader = ({ loading = false }) => {
  if (!loading) {
    return null;
  }

  return (
    <Spin
      className={styles.root}
      indicator={
        <Icon type="loading" style={{ fontSize: 24, color: '#fff' }} spin />
      }
    />
  );
};

export default Loader;
